import { BreakpointObserver } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { Component, HostListener, ViewChild } from '@angular/core';
import { GradientBoxComponent } from '@app/shared/gradient-box/gradient-box.component';
import { SlideViewerComponent } from '@app/shared/slide-viewer/slide-viewer.component';
import { Labels } from '@core/constants/labels';
import { FilterDataImages } from '@core/models/filter-data-images.model';
import { Image } from '@core/models/image.model';
import { ImageFilterComponent } from './components/image-filter/image-filter.component';
import { ImageMosaicComponent } from './components/image-mosaic/image-mosaic.component';
@Component({
  selector: 'app-image-database',
  standalone: true,
  imports: [
    ImageFilterComponent,
    ImageMosaicComponent,
    SlideViewerComponent,
    GradientBoxComponent,
    CommonModule,
  ],
  templateUrl: './image-database.component.html',
  styleUrl: './image-database.component.scss',
})
export class ImageDatabaseComponent {
  labels = Labels.DASHBOARD;

  filterData: FilterDataImages | null = null;
  selectedImageId: number = -1;
  selectedImage: Image | null = null;

  @ViewChild('toolContainer') toolContainer: any;
  @ViewChild('toolDiv') toolDiv: any;
  @ViewChild('viewerDiv') viewDiv: any;
  @ViewChild('resizeHandle') resizeHandle: any;
  @ViewChild('handleContainer') handleContainer: any;

  observerRegistered = false;

  lastPoint = { x: 0, y: 0 };
  dragging = false;
  isPortrait = false;

  constructor(private breakpointObserver: BreakpointObserver) {
    this.breakpointObserver
      .observe(['(orientation: portrait)'])
      .subscribe((state) => {
        this.isPortrait = state.matches;
      });
  }

  @HostListener('document:mousedown', ['$event'])
  mouseDown(event: any) {
    if (this.resizeHandle.nativeElement.contains(event.target)) {
      this.lastPoint = { x: event.clientX, y: event.clientY };
      this.dragging = true;
    }
  }

  @HostListener('document:touchstart', ['$event'])
  touchStart(event: any) {
    this.mouseDown(event.touches[0]);
  }

  @HostListener('document:mouseup', ['$event'])
  mouseUp(event: any) {
    this.dragging = false;
  }

  @HostListener('document:touchend', ['$event'])
  touchEnd(event: any) {
    this.mouseUp(event);
  }

  @HostListener('document:mousemove', ['$event'])
  mouseMove(event: any) {
    const yDiff = event.clientX - this.lastPoint.x;
    this.lastPoint = { x: event.clientX, y: event.clientY };
    if (this.dragging) {
      event.stopPropagation();
      event.preventDefault();
      this.updateSize(yDiff);
    }
  }

  @HostListener('document:touchmove', ['$event'])
  touchMove(event: any) {
    const yDiff = event.touches[0].clientX - this.lastPoint.x;
    this.lastPoint = { x: event.touches[0].clientX, y: event.clientY };
    if (this.dragging) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  getInternalHeight(elem: any) {
    const cs = getComputedStyle(elem);
    return (
      elem.offsetHeight -
      (parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom)) -
      (parseFloat(cs.borderTopWidth) + parseFloat(cs.borderBottomWidth))
    );
  }

  getExternalHeight(elem: any) {
    const cs = getComputedStyle(elem);
    return (
      elem.offsetHeight + parseFloat(cs.marginTop) + parseFloat(cs.marginBottom)
    );
  }

  updateSize(increment: number) {
    const currentToolWidth = this.toolContainer.nativeElement.offsetWidth;
    const currentViewerWidth = this.viewDiv.nativeElement.offsetWidth;
    this.toolContainer.nativeElement.style.width = `${currentToolWidth + increment}px`;
    this.viewDiv.nativeElement.style.width = `${currentViewerWidth - increment}px`;
  }

  registerObserver() {
    if (this.viewDiv === undefined) return;

    this.observerRegistered = true;

    const observer = new ResizeObserver((entries) => {
      const parentHeight = this.getInternalHeight(
        this.toolContainer.nativeElement,
      );

      const offsetHeightHandle = this.getExternalHeight(
        this.handleContainer.nativeElement,
      );

      this.toolDiv.nativeElement.style.height = `${parentHeight - offsetHeightHandle}px`;
    });
    observer.observe(this.toolContainer.nativeElement);
  }

  ngAfterViewInit() {
    if (!this.observerRegistered) {
      this.registerObserver();
    }
  }

  updateSelectedImage(image: Image) {
    this.selectedImage = image;
    this.selectedImageId = image.id;
  }
}
